import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Remove } from "../../../capacitiesTypes";

export const FETCH_DELETE_CAPACITIES_TYPES_REQUEST = 'FETCH_DELETE_CAPACITIES_TYPES_REQUEST';
export const FETCH_DELETE_CAPACITIES_TYPES_SUCCESS = 'FETCH_DELETE_CAPACITIES_TYPES_SUCCESS';
export const FETCH_DELETE_CAPACITIES_TYPES_FAILURE = 'FETCH_DELETE_CAPACITIES_TYPES_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDeleteCapacitiesTypeRequest = () => {
    return {
        type: FETCH_DELETE_CAPACITIES_TYPES_REQUEST,
    };
};

const fetchDeleteCapacitiesTypeSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DELETE_CAPACITIES_TYPES_SUCCESS,
        payload: data
    };
};

const fetchDeleteCapacitiesTypeFailure = (error: any) => {
    return {
        type: FETCH_DELETE_CAPACITIES_TYPES_FAILURE,
        payload: error,
    };
};

export const remove = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDeleteCapacitiesTypeRequest());
        try {
            await Remove(id);
            dispatch(fetchDeleteCapacitiesTypeSuccess(true));
        } catch (error: any) {
            dispatch(fetchDeleteCapacitiesTypeFailure(error.message));
        }
    };
};
